import { apiClientWithRefreshToken } from "@/api/apiClient";

export default async function DeleteMobilization(id: string): Promise<void> {
    await apiClientWithRefreshToken({
        url: `/mobilizations/${id}`,
        method: "DELETE",
    });
}
